export const TableHeaders = {
  column1: 'Category',
  column2: 'Representative Examples',
  column3: 'Collected'
};

export const TableData = [
  {
    column1: '1. Identifiers',
    column2:
      'A real name, alias, postal address, unique personal identifier, online identifier, Internet Protocol address, email address, account name, Social Security number, driver’s license number, passport number, or other similar identifiers.',
    column3: 'YES'
  },
  {
    column1:
      '2. Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e)).',
    column2:
      'A name, social security number, address, telephone number, passport number, driver’s license or state identification card number, insurance policy number, education, employment, employment history, bank account number, credit card number, debit card number, or any other financial information. Some personal information included in this category may overlap with other categories.',
    column3: 'YES'
  },
  {
    column1:
      '3. Protected classification characteristics under California or federal law.',
    column2: 'Age (including 40 years or older), citizenship, and sex.',
    column3: 'YES'
  },
  {
    column1: '4. Commercial information.',
    column2:
      'Records of personal property, products or services purchased, obtained, or considered, or other purchasing or consuming histories or tendencies.',
    column3: 'YES'
  },
  {
    column1: '5. Biometric information.',
    column2:
      'Genetic, physiological, behavioral, and biological characteristics, or activity patterns used to extract a template or other identifier or identifying information, such as, fingerprints, faceprints, and voiceprints, iris or retina scans, keystroke, gait, or other physical patterns, and sleep, health, or exercise data.',
    column3: 'NO'
  },
  {
    column1: '6. Internet or other similar network activity.',
    column2:
      'Browsing history, search history, information on a consumer’s interaction with a website, application, or advertisement.',
    column3: 'YES'
  },
  {
    column1: '7. Geolocation data.',
    column2: 'Physical location or movements.',
    column3: 'YES'
  },
  {
    column1: '8. Sensory data.',
    column2:
      'Audio, electronic, visual, thermal, olfactory, or similar information.',
    column3: 'NO'
  },
  {
    column1: '9. Professional or employment-related information.',
    column2: 'Current or past job history or performance evaluations.',
    column3: 'YES'
  },
  {
    column1:
      '10. Non-public education information (per the Family Educational Rights and Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part 99))',
    column2:
      'Education records directly related to a student maintained by an educational institution or party acting on its behalf, such as grades, transcripts, class lists, student schedules, student identification codes, student financial information, or student disciplinary records.',
    column3: 'NO'
  },
  {
    column1: '11. Inferences drawn from other personal information.',
    column2:
      'Profile reflecting a person’s preferences, characteristics, psychological trends, predispositions, behavior, attitudes, intelligence, abilities, and aptitudes.',
    column3: 'YES'
  }
];
